import { Address } from '@checkout-v2/const';

export type AddressAdditionalData = Pick<
  Address,
  'country' | 'regionName' | 'district' | 'town' | 'streetname' | 'streetnumber' | 'point'
>;

export type Nullable<T> = { [P in keyof T]: T[P] | null };

export interface AddressData {
  address: string;
  appartment: string;
  entrance: string;
  floor: number;
  heightLimit: number;
  widthLimit: number;
  hasLimit: boolean;
  domofon: string;
  privateHouse: boolean;
  cargoLift: boolean;
  passengerLift: boolean;
  carryingDistance: number;
  addressAdditionalData: AddressAdditionalData;
}

export function mapAddressToFormData(address: Partial<Address>): Nullable<AddressData> {
  return {
    address: address.formattedAddress ?? null,
    appartment: address.appartment || null,
    entrance: address.entrance || null,
    domofon: address.domofon || null,
    floor: address.floor || null,
    hasLimit: !!address.heightLimit || !!address.widthLimit,
    heightLimit: address.heightLimit ?? null,
    widthLimit: address.widthLimit ?? null,
    privateHouse: address.privateHouse || null,
    passengerLift: address.passengerLift || null,
    cargoLift: address.cargoLift || null,
    carryingDistance: address.carryingDistance || null,
    addressAdditionalData: address.country
      ? {
          country: address.country,
          regionName: address.regionName,
          district: address.district,
          town: address.town,
          streetname: address.streetname,
          streetnumber: address.streetnumber,
          point: address.point,
        }
      : null,
  };
}

export function mapFormDataToAddress(data: AddressData, addressId?: string): Address {
  return {
    country: data.addressAdditionalData.country,
    regionName: data.addressAdditionalData.regionName,
    district: data.addressAdditionalData.district,
    town: data.addressAdditionalData.town,
    streetname: data.addressAdditionalData.streetname,
    streetnumber: data.addressAdditionalData.streetnumber,
    point: data.addressAdditionalData.point,
    appartment: data.appartment,
    entrance: data.entrance,
    domofon: data.domofon,
    floor: data.floor,
    heightLimit: data.hasLimit ? (data.heightLimit ?? undefined) : undefined,
    widthLimit: data.hasLimit ? (data.widthLimit ?? undefined) : undefined,
    formattedAddress: data.address,
    id: addressId,
    privateHouse: data.privateHouse,
    passengerLift: data.passengerLift,
    cargoLift: data.cargoLift,
    carryingDistance: data.carryingDistance,
  };
}
